// Prevent theme flash by setting theme before React loads
(function () {
  const theme = localStorage.getItem("theme") || "light";
  document.documentElement.setAttribute("data-theme", theme);
})();

import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import { initializeUrlFilterSync } from "#/stores/url-filter-store";

// Initialize URL filter sync for browser back/forward navigation
initializeUrlFilterSync();

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.env.PROD || !import.meta.hot) {
  createRoot(elem).render(app);
} else {
  const hotData = import.meta.hot.data as { root?: ReturnType<typeof createRoot> };
  const root = (hotData.root ??= createRoot(elem));
  root.render(app);
}
